import EmptyState from "../../../components/EmptyState/index.js";
import LoadingState from "../../../components/LoadingState/index.js";

type FirmLogoCopyStatusProps = {
  isBusy: boolean;
  isRefetching: boolean;
  error: Error | null;
  isEmpty: boolean;
  hasFilters: boolean;
  onRetry: () => void;
};

export function FirmLogoCopyStatus({
  isBusy,
  isRefetching,
  error,
  isEmpty,
  hasFilters,
  onRetry,
}: FirmLogoCopyStatusProps) {
  return (
    <div aria-live="polite">
      {isBusy ? (
        <LoadingState message={isRefetching ? "Retrying…" : "Loading the planned logo copy…"} />
      ) : null}

      {!isBusy && error ? (
        <EmptyState
          variant="error"
          title="The planned logo copy couldn't be loaded"
          message={error.message}
          action={{ label: "Retry", onClick: onRetry }}
        />
      ) : null}

      {!isBusy && !error && isEmpty ? (
        <EmptyState
          variant="empty"
          title="Nothing to show"
          message={
            hasFilters ? "No rows match these filters." : "The copy has nothing to do right now."
          }
        />
      ) : null}
    </div>
  );
}
